export * from './delete-formular.component';
export * from './delete-formular.component.module';